import { useTranslation } from "react-i18next";

import { NothingConfigured, Typography } from "@digital-services/ui";

import BigApplicationIcon from "@icons/application_96.svg?react";

import { AddApplicationRolesButton } from "./AddApplicationRolesButton";

interface Props {
  message1?: string;
  message2?: string;
}

export function NoAppRolesConfigured(props: Readonly<Props>) {
  const { t: tApiUserTab } = useTranslation(undefined, {
    keyPrefix: "api-users"
  });

  const msg1 = props.message1 || "There are no application roles yet";
  const msg2 = props.message2 || tApiUserTab("messages.users-no-data-2");

  return (
    <NothingConfigured
      title={msg1}
      icon={<BigApplicationIcon />}
      actionButton={
        <div className="mt-8">
          {false ? <AddApplicationRolesButton /> : null}
        </div>
      }
    >
      <Typography className="max-w-[260px] text-center" variant="description">
        {msg2}
      </Typography>
    </NothingConfigured>
  );
}
